import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "rc-time-picker/assets/index.css";
import Checkbox from "@material-ui/core/Checkbox";

const WeekDayCheckboxes = (props) => {
  const { t } = useTranslation();
  const [selectedWeekdays, setSelectedWeekdays] = useState(
    props.selectedWeekdays ?? []
  );
  const setWeekdaysForParent = props.setWeekdays;

  const weekDaysNumber = [1, 2, 3, 4, 5, 6, 0];
  const weekDaysText = [
    t("allgemein.tageKurz.Monday"),
    t("allgemein.tageKurz.Tuesday"),
    t("allgemein.tageKurz.Wednesday"),
    t("allgemein.tageKurz.Thursday"),
    t("allgemein.tageKurz.Friday"),
    t("allgemein.tageKurz.Saturday"),
    t("allgemein.tageKurz.Sunday"),
  ];

  function setSelected(weekdays) {
    setSelectedWeekdays(weekdays);
    setWeekdaysForParent(weekdays);

    console.debug("new selectedWeekdays %o", weekdays);
  }

  return (
    <div className="flex-iac">
      {weekDaysNumber.map((value, index) => {
        return (
          <div className="flex-iac">
            {weekDaysText[index]}
            <Checkbox
              color="primary"
              size="small"
              style={{ padding: "5px", paddingRight: "10px" }}
              value={value}
              onChange={(e) => {
                console.debug(
                  "CheckBox changed Checked: %o; Value: %o; selectedWeekdays (old): %o",
                  e.target.checked,
                  value,
                  selectedWeekdays
                );

                if (e.target.checked == true) {
                  setSelected([...selectedWeekdays, parseInt(e.target.value)]);
                } else {
                  setSelected(selectedWeekdays.filter((w) => w !== value));
                }
              }}
              checked={selectedWeekdays.includes(value)}
            />
          </div>
        );
      })}
      <div className="flex-iac">
        <button
          type="button"
          id=""
          style={{
            width: "auto",
            marginRight: "2px",
            color: "blue",
            border: "none",
            backgroundColor: "white",
          }}
          onClick={() => {
            setSelected(weekDaysNumber);
          }}
        >
          {t("allgemein.alle")}
        </button>
        |
        <button
          type="button"
          id=""
          style={{
            width: "auto",
            marginLeft: "2px",
            color: "blue",
            border: "none",
            backgroundColor: "white",
          }}
          onClick={() => {
            setSelected([]);
          }}
        >
          {t("allgemein.keine")}
        </button>
      </div>
    </div>
  );
};

export default WeekDayCheckboxes;
